import { useSuspenseQuery } from "@apollo/client/react";

import {
  GetPropertySchemaSetDocument,
  type GetPropertySchemaSetQuery,
  type GetPropertySchemaSetQueryVariables,
} from "~/features/admin/recordMetadataSchema/gqls";

/**
 * Record-metadata schema detail (property-schema associations + audit
 * timestamps), keyed by the property-schema-set id. Tenant scoping is enforced
 * server-side, so no tenantId variable is passed — V1 parity.
 */
export function useRecordMetadataSchemaDetail(id: string) {
  return useSuspenseQuery<GetPropertySchemaSetQuery, GetPropertySchemaSetQueryVariables>(GetPropertySchemaSetDocument, {
    variables: { id },
  });
}
